import cs from 'classnames';
import { useStyles } from '../style';

const TitleCell = ({ text }) => {
  const classes = useStyles({});

  return <div className={cs(classes.baseCell, classes.titleCell)}>{text}</div>;
};

export default TitleCell;
